import React from 'react';
import type { MediaTextOverlay } from '../types';

interface MediaTextOverlayProps {
  overlay?: MediaTextOverlay | null;
  className?: string;
}

const STYLES: Record<NonNullable<MediaTextOverlay['style']>, string> = {
  classic: 'bg-black/40 text-white shadow-[0_10px_30px_rgba(0,0,0,0.32)]',
  capsule: 'bg-white/92 text-black shadow-[0_12px_32px_rgba(0,0,0,0.24)]',
  outline: 'bg-black/20 text-white border border-white/65 shadow-[0_10px_28px_rgba(0,0,0,0.3)]',
};

const MediaTextOverlay: React.FC<MediaTextOverlayProps> = ({ overlay, className = '' }) => {
  const trimmed = overlay?.text?.trim();
  if (!trimmed) return null;

  const yPercent = Math.min(88, Math.max(12, overlay?.yPercent ?? 72));
  const styleKey = overlay?.style || 'classic';

  return (
    <div
      className={`pointer-events-none absolute inset-x-0 z-[2] flex justify-center px-5 ${className}`.trim()}
      style={{ top: `${yPercent}%`, transform: 'translateY(-50%)' }}
    >
      <div
        className={`max-w-[92%] rounded-[1.6rem] px-4 py-2 text-center text-base font-black leading-tight tracking-[0.01em] backdrop-blur-md md:text-lg ${STYLES[styleKey]}`}
      >
        {trimmed}
      </div>
    </div>
  );
};

export default MediaTextOverlay;
